import * as React from "react";

function SvgCheckCircle({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M12 2.25c5.186 0 9.442 4.053 9.734 9.197l.012.277.004.276c0 5.186-4.053 9.442-9.197 9.734l-.277.012-.276.004c-5.186 0-9.442-4.053-9.734-9.197l-.012-.277L2.25 12c0-5.186 4.053-9.442 9.197-9.734l.277-.012L12 2.25zm0 1.5l-.244.004c-4.369.126-7.872 3.643-8.002 7.984l-.004.251.004.255c.126 4.369 3.643 7.872 7.984 8.002l.251.004.255-.004c4.369-.126 7.872-3.643 8.002-7.984l.004-.251-.004-.255A8.248 8.248 0 0012 3.75zm4.53 5.72a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-3-3a.749.749 0 01.976-1.133l.084.073L11 13.939l4.47-4.47a.75.75 0 011.06 0z"
        />
      </g>
    </svg>
  );
}

export default SvgCheckCircle;
